<template>
    <div class="article-list">
        <div class="article-add">
            <el-button type="primary"
                       @click="articleAdd">Create</el-button>
        </div>
        <div class="article-content">
            <el-table :data="articleList">
                <el-table-column prop="id"
                                 label="id"></el-table-column>
                <el-table-column prop="titleEN"
                                 label="Title"></el-table-column>
                <el-table-column prop="createTime"
                                 label="Created Time"></el-table-column>
                <el-table-column prop="modifyTime"
                                 label="last Edit"></el-table-column>
                <el-table-column prop="status"
                                 label="Show or Not">
                    <template slot-scope="scoped">{{scoped.row.status==0?'Hidden':'Showed'}}</template>
                </el-table-column>
                <el-table-column label="Operation">
                    <template slot-scope="scoped">
                        <div class="article-operation">
                            <!-- <router-link tag="span"
                                         :to="'/article/edit?id='+scoped.row.id">Edit</router-link> -->
                            <span @click="editBlogById(scoped.row.id)">Edit</span>
                            <span>|</span>
                            <span @click="delBlogById(scoped.row)">Delete</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page.sync="currentPage"
                               :page-size="pageSize"
                               layout=" prev, pager, next"
                               :total="total"
                               v-if="total !=0">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@api/cooperation'
export default {
    data () {
        return {
            articleList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0
        }
    },
    methods: {
        handleSizeChange () {

        },
        handleCurrentChange (newPage) {
            this.fetchArticleList()
        },
        async fetchArticleList () {
            let params = {
                pageNo: this.currentPage,
                pageSize: this.pageSize,
            }
            const res = await api.queryBlogList(params)
            if (res.success) {
                this.articleList = res.data.list
                this.currentPage = res.data.pageNum
                this.pageSize = res.data.pageSize
                this.total = res.data.total
            }
        },
        articleAdd () {
            this.$router.push({ name: 'articleEdit', params: { pageNo: this.currentPage } })
        },
        editBlogById (id) {
            this.$router.push({ path: '/article/edit', query: { id: id, pageNo: this.currentPage } })
        },
        async delBlogById (row) {
            console.log(row)
            const ctx = await this.$confirm('This action will permanently delete the article and whether to continue?', 'Tip', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).catch(err => {
                this.$message({
                    type: 'info',
                    message: 'Cancel delete'
                });
            })
            if (ctx == 'confirm') {
                let params = { blogId: row.id }
                const res = await api.delBlog(params)
                if (res.success == true) {
                    this.$message.success('Delete blog successfully!')
                    this.fetchArticleList()
                }
            }
        }
    },
    mounted () {
        if (this.$route.params && this.$route.params.pageNo) {
            this.currentPage = this.$route.params.pageNo
        }
        this.fetchArticleList()
    }
}
</script>
<style scoped>
.article-list {
    margin-bottom: 20px;
    margin-top: 50px;
    margin-left: 250px;
}
.article-add {
    padding: 20px;
    border-bottom: 1px solid #e4e4e4;
}
.article-operation {
    display: flex;
    align-items: center;
    color: rgb(70, 162, 255);
}
.article-operation span {
    margin-right: 10px;
    cursor: pointer;
}
.pagination {
    /* margin-left: 250px; */
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    /* position: fixed;
    left: 0;
    right: 0;
    bottom: 20px; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/articleList.vue